// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__QvrAV","header":"Menu_header__UnGxr","body":"Menu_body__a0Qim"};